import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_REFER_TYPE_REQUEST: '',
  GET_REFER_TYPE_SUCCESS: '',
  GET_REFER_TYPE_FAILURE: '',
};

types = setStoreTypeValues(types, 'authReferType');

export default types;
